export const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: '2-digit'}
    return new Date(dateString).toLocaleDateString(undefined, options)
}

export const formatTime = (timeString) => {
    const options = { hour: '2-digit', minute: '2-digit', second: '2-digit'}
    return new Date(timeString).toLocaleTimeString(undefined, options)
}

